import * as yup from 'yup';

declare module 'yup' {
  interface ObjectSchema<
    TIn extends yup.Maybe<yup.AnyObject>,
    TContext = yup.AnyObject,
    TDefault = any,
    TFlags extends yup.Flags = '',
  > {
    debugValidationResolver(): this;
  }
}

export const DebugValidationResolverMetaKey = '__debugYupResolverErrors';

yup.addMethod(
  yup.object,
  'debugValidationResolver',
  function (this: yup.ObjectSchema<yup.AnyObject>) {
    return this.meta({ [DebugValidationResolverMetaKey]: true });
  },
);
